export const buildinfo = {
    timeStamp: '2026_11_12_26.1308.1',
};
